import { config } from 'src/config'

import { documents } from './Documents'
import { partners } from './Partner'
import { reassign } from './Reassign'
import { statistics } from './Statistics'
import { user } from './User'

const { featureExport } = config.features

export const resources = featureExport
  ? [user, statistics, partners, reassign, ...documents]
  : [user, statistics, ...documents]
